import { type Response, sendGet, sendPost } from '../hooks/use-fetch'
import { type RecentTrackingChangesResponseModel, type ResolveTrackingChangeValues } from '../models/TrackingChange'

export async function GetRecentTrackingChangesForAnnualPlan (
  annualPlanId: number,
  includeResolved: boolean
): Promise<Response<RecentTrackingChangesResponseModel>> {
  return await sendGet(`TrackingChange/GetRecentTrackingChangesForAnnualPlan?annualPlanId=${annualPlanId}&includeResolved=${String(includeResolved)}`)
}

export async function ResolveTrackingChange (values: ResolveTrackingChangeValues): Promise<Response> {
  return await sendPost('TrackingChange/ResolveTrackingChange', values)
}
